import React, { createContext, useContext, useEffect, useState } from 'react';
import { getUsdRate, isValidUsdRate, convertFromIls, rateForCurrency } from '../services/exchangeRateService';

const ExchangeRateContext = createContext(null);
const CurrencyContext = createContext({ currency: 'ILS', setCurrency: () => {} });
const supported = ['ILS', 'USD', 'EUR'];

export function ExchangeRateProvider({ enabled, children }) {
  const [selected, setSelected] = useState(() => {
    try { const saved = localStorage.getItem('diam.displayCurrency.v1'); if (supported.includes(saved)) return saved; } catch {}
    return 'USD';
  });
  const setCurrency = value => {
    if (!supported.includes(value)) return;
    setSelected(value);
    try { localStorage.setItem('diam.displayCurrency.v1', value); } catch {}
  };
  const [rate, setRate] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const refresh = () => getUsdRate().then(value => { if (alive) setRate(value); });
    const onFocus = () => { if (!document.hidden) refresh(); };
    refresh();
    const timer = setInterval(onFocus, 60000);
    window.addEventListener('focus', onFocus);
    window.addEventListener('online', onFocus);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('focus', onFocus); window.removeEventListener('online', onFocus); };
  }, [enabled]);
  return <CurrencyContext.Provider value={{ currency: enabled ? selected : 'ILS', setCurrency, enabled }}><ExchangeRateContext.Provider value={enabled && isValidUsdRate(rate) ? rate : null}>{children}</ExchangeRateContext.Provider></CurrencyContext.Provider>;
}

export const useExchangeRate = () => useContext(ExchangeRateContext);

export const useDisplayCurrency = () => {
  const choice = useContext(CurrencyContext);
  const rate = useExchangeRate();
  const currency = choice.currency === 'ILS' || rateForCurrency(rate, choice.currency) ? choice.currency : 'ILS';
  const format = amount => {
    const converted = convertFromIls(amount, rate, currency);
    if (converted === null) return '—';
    const symbol = { ILS: '₪', USD: 'US$', EUR: '€' }[currency];
    return `\u2066${currency === 'ILS' ? '' : '≈ '}${symbol}${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(converted)}\u2069`;
  };
  return { ...choice, effectiveCurrency: currency, format };
};
